<div class="cart-title row">
  <p class="miniCart-title">{{'common.basket_added_to_basket'|cxTranslate}}
    <span>
      <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close-light-grey.svg" alt="" class="" width="20" />
      </button>
    </span>
  </p>
</div>

<mat-dialog-content class="mat-typography overflow-x-hidden">
  @for (prod of _data.cartData; track prod) {
    <div class="cart_popup_error_msg">
      {{
      {message:prod?.statusMessage,errorValue1:prod?.entry?.entryNumber,errorValue2:prod?.entry?.product.code}|updateValue
      }}
    </div>
    <div class="mini-cart-insideBlock row">
      <ol class="col-sm-12 col-md-7 mini-cart-list ">
        <li class="mini-cart-item row">
          <div class="thumb width-auto padding-sm-0">
            <a [routerLink]="{cxRoute: 'product',params: prod?.entry?.product} | cxUrl " mat-dialog-close>
              <cx-media
                [container]="prod?.entry?.product?.images?.['PRIMARY'] || prod?.entry?.product?.images || null">
              </cx-media>
            </a>
          </div>
          <div class="details padding-sm-0">
            <a [routerLink]="{cxRoute: 'product',params: prod?.entry?.product} | cxUrl " mat-dialog-close
            class="product-code">{{prod.entry.product.code}}</a>
            <p [routerLink]="{cxRoute: 'product',params: prod?.entry?.product} | cxUrl " mat-dialog-close
              class="prod-desc">
            {{prod.entry.product.typenumber}}</p>
            <p class="prod-desc">{{prod.entry.product.name}}</p>
            <p class="prod-green">{{prod.entry.product.salesStatus}}</p>
            <p class="prod-desc" style="white-space: nowrap;">{{prod.entry.product.marketType}}</p>
          </div>
        </li>
      </ol>
      <div class="col-sm-12 col-md-5 mini-cart-details">
        <div class="mini-cart-totals">
          @if (fleetPrideGroup && showNetPrice$|async) {
            <div class="rower">
              <div class="prod-desc">
              {{'common.popup_cart_customer_price'|cxTranslate}}</div>
              <div class="price">
                @if (!(prod?.entry.product?.netPrice?.formattedValue)) {
                  <span
                  >{{'common.basket_page_poa'|cxTranslate}}</span>
                }
                @if (prod?.entry.product?.netPrice?.formattedValue) {
                  <span>
                    <strong>{{prod.entry.product?.netPrice.formattedValue}}
                    {{prod.entry.product?.netPrice.currencyIso}}</strong></span>
                  }
                </div>
              </div>
            }
            @if (fleetPrideGroup &&showListPrice$|async) {
              <div class="rower">
                <div class="prod-desc">
                {{'common.netPrice_check'|cxTranslate}}</div>
                <div class="price">
                  @if (!(prod?.entry.product?.listPrice?.formattedValue)) {
                    <span>
                      <strong>{{'common.basket_page_poa'|cxTranslate}}</strong>
                    </span>
                  }
                  @if (prod?.entry.product?.listPrice?.formattedValue) {
                    <span>
                      <strong>{{prod?.entry.product?.listPrice.formattedValue}}
                      {{prod?.entry.product?.listPrice.currencyIso}}</strong></span>
                    }
                  </div>
                </div>
              }
              <div class=" rower">
                <div class="prod-desc">
                {{'common.popup_cart_quantity_added'|cxTranslate}} : </div>
                <div class="price">{{prod.quantityAdded}}</div>
              </div>
            </div>
          </div>
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class=" d-flex flex-column downButtons">
        <a class="btn button" [routerLink]="{ cxRoute: 'cart' } | cxUrl"
          mat-dialog-close>{{'common.checkout_checkout'|cxTranslate}}
          <img src="/icons/link-grey.svg" class="icon-right" alt="">
        </a>
        <a mat-dialog-close class=" btn button-launch">{{'common.general_continue_shopping'|cxTranslate}}</a>
      </div>
    </mat-dialog-actions>
